import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { of } from 'rxjs';

const submitShellDisplay: IShellDisplay = {
  route: '/pages/facility-maintenance/submit',
  navTitleKey: l10n('FACILITY_MAINTENANCE.SUBMIT.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:pencil-write-2',
  hideNavBar$: of(true),
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: submitShellDisplay, multi: true },
  ],
})
export class FacilityMaintenanceMetadataModule {}
